export default function StatCard({ icon: Icon, label, value, testid, accent }) {
    return (
        <div
            data-testid={testid}
            className="bg-white rounded-2xl border border-border p-5 hover:shadow-md transition-shadow"
        >
            <div className="flex items-center justify-between">
                <span className={`text-2xl ${accent || "text-primary"}`}>
                    {Icon && <Icon weight="fill" />}
                </span>
                <span className="text-xs uppercase tracking-widest text-muted-foreground font-bold">
                    {label}
                </span>
            </div>
            <p className="font-display font-black text-3xl mt-3">{value}</p>
        </div>
    );
}
